import { render, staticRenderFns } from "./SiteButton.vue?vue&type=template&id=2031cd84"
import script from "./SiteButton.vue?vue&type=script&lang=js"
export * from "./SiteButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports